import { ReactNode, createContext, useContext, useEffect, useState } from "react";

import { Org } from "@zickko/shared";
import { useParams } from "react-router-dom";
import { clientRepo } from "../repo/clientRepo";
import { toastStore } from "../utils/toastStore";

type ContextInfo = {
  org: Org;
};

export const OrgContext = createContext<ContextInfo>({} as any);

type Props = { children: ReactNode };

const OrgProvider = (props: Props) => {
  //
  const { orgId } = useParams();
  const [org, setOrg] = useState<Org | null>();

  // login
  if (!orgId) {
    return <div>Please check the URL. `orgId` expected in path.</div>;
  }

  useEffect(() => {
    // get org
    clientRepo.org.get({ orgId }).then((doc) => {
      if (doc) {
        setOrg(doc);
        return;
      }
      toastStore.error(`Cannot find requested org.`);
      setOrg(null);
    });
  }, [orgId]);

  if (org === undefined) {
    return <div>Loading org ...</div>;
  }

  if (org === null) {
    return <div>Org not found.</div>;
  }

  return <OrgContext.Provider value={{ org }}>{props.children}</OrgContext.Provider>;
};

function useOrg() {
  return useContext(OrgContext);
}

export { OrgProvider, useOrg };
